// extracted by mini-css-extract-plugin
export var fadeIn = "_gv-1";
export var modalContent = "_gv-3";
export var overlay = "_gv-0";
export var popoverContent = "_gv-2";
export var results = "_gv-5";
export var searchInputWrapper = "_gv-4";